import {
    saveLocalStorage,
    getToken,
    getLocalStorage,
  } from "components/Helper/Helper";
  import { Config } from "../../../Config.js";
  import { showLoading, hideLoading } from "react-redux-loading-bar";
  import axios from "axios";
  import { COMMON_MSGS } from "Constant/Messages";
import { SAVE_TRACK_RETURN, SAVE_VALIDATION_DATA } from "./constants.js";
 
export function saveGstrreturnTrackSummary(payload) {
    return {
      type: SAVE_TRACK_RETURN,
      data: payload,
    };
  }
 
  export function saveGstnvalidationData(payload) {
    return {
      type: SAVE_VALIDATION_DATA,
      data: payload,
    };
  }
export const getGstrTrackSummay = (gstin, fy, isRefresh=false) => {
    return (dispatch) => {
      console.log(gstin, "gstin", "fyear", fy);
      if(fy == ""){
        dispatch(saveGstrreturnTrackSummary([]));
      }
      else{
      const data = {
        gstin,
        fy,
        isRefresh,
      };
      dispatch(saveGstrreturnTrackSummary([]));
    //   dispatch(loader(true));
      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          url: `${Config.url}gstrdatafetch/getGstrReturnSummary`,
          data: data,
          headers: {
            token: getLocalStorage("loginDetails"),
          },
        })
          .then((response) => {
            if (response.data.error != 1) {
              // Process the data to combine GSTR1 and GSTR3B by filing period
              const rawData = response.data.data.length ? response.data.data[0].data_json : [];
             
              // Filter only GSTR1 and GSTR3B data
              const filteredData = rawData.filter(item =>
                item.hasOwnProperty('GSTR1') || item.hasOwnProperty('GSTR3B')
              );
             
              // Group by filing period and combine GSTR1 & GSTR3B dates
              const groupedData = {};
             
              filteredData.forEach(item => {
                const filingPeriod = item.fillingPeriod;
               
                if (!groupedData[filingPeriod]) {
                  groupedData[filingPeriod] = {
                    fillingPeriod: filingPeriod,
                    GSTR1: null,
                    GSTR3B: null
                  };
                }
               
                if (item.GSTR1) {
                  groupedData[filingPeriod].GSTR1 = item.GSTR1;
                }
               
                if (item.GSTR3B) {
                  groupedData[filingPeriod].GSTR3B = item.GSTR3B;
                }
              });
             
              // Convert grouped data back to array
              const processedData = Object.values(groupedData);
             
              dispatch(saveGstrreturnTrackSummary(processedData));
            }
            // dispatch(loader(false));
            resolve(response.data);
          })
          .catch((error) => {
            // dispatch(loader(false));
            console.log(error);
            reject(true);
          });
      });
    }
    };
};
 
export const getGstnValidationSummay = (gstin, isRefresh=false) => {
 
return (dispatch) => {
    const data = {
    gstin,
    isRefresh,
    };
    // dispatch(loader(true));
    return new Promise((resolve, reject) => {
    axios({
        method: "post",
        url: `${Config.url}validateGstn/fetchSingleGstin`,
        data: data,
        headers: {
        token: getLocalStorage("loginDetails"),
        },
    })
        .then((response) => {
        if (response.data.error != 1) {
            dispatch(saveGstnvalidationData(response.data.data));
        }
        console.log("GSTIN Detail Data :: ", response.data);
        // dispatch(loader(false));
        resolve(response.data);
        })
        .catch((error) => {
        // dispatch(loader(false));
        console.log(error);
        reject(true);
        });
    });
};
};